// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2hHzq","label":"Labeled_label__2A3oW","divider":"Labeled_divider__3lw0F"};